/**
 * Find and remove the given element from the given list.
 */
export const removeElement = <T>(list: T[], elt: T) => {
    const i = list.indexOf(elt);
    list.splice(i, 1);
};
export default removeElement;
